import { render, staticRenderFns } from "./DispatchRowStatus.vue?vue&type=template&id=d0c4ddfe"
import script from "./DispatchRowStatus.vue?vue&type=script&lang=js"
export * from "./DispatchRowStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports